import styled from 'styled-components';
import { colors, fonts, fontSizes, device } from 'shared/defaultTheme';
import { TextField } from 'shared/components/form/Inputs';

export const ContainerIcon = styled.div`
  flex: 0 0 3%;
  margin-right: 10px;
  margin-left: 10px;
`;

export const ContainerIconHide = styled.div`
  flex: 0 0 3%;
  margin-right: 10px;
  margin-left: 10px;
  visibility: hidden;
`;

export const H5 = styled.h5`
  color: ${colors.black} !important;
  font-family: ${fonts.default};
  font-size: ${fontSizes.lg}px;
  font-weight: ${({ isClient }) => (isClient ? 'bold' : '500')};
  letter-spacing: 0;
  line-height: 18px;
  margin-left: ${({ isClient }) => (isClient ? '10px' : '0')};
  margin-top: ${({ isClient }) => (isClient ? '5px' : '0')};
`;

export const H6 = styled.h6`
  color: ${colors.black} !important;
  font-family: ${fonts.default};
  font-size: ${fontSizes.sm}px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
  margin-bottom: 5px;
`;

export const Hr = styled.hr`
  margin-bottom: 30px;
  box-sizing: border-box;
  border: 1px solid ${colors.pattens};
`;

export const HrComment = styled.hr`
  box-sizing: border-box;
  border: 1px solid ${colors.pattens};
`;

export const ContainerComment = styled.div`
  border-radius: 8px;
  background-color: ${colors.whiteSmoke};
  margin-top: 30px;
  padding: 5px;
  cursor: ${({ showTextEditor }) => !showTextEditor && 'pointer'};
  padding-bottom: ${({ showTextEditor }) => (!showTextEditor ? '5px' : ' 12px')};
  .attachment-box-container {
    background-color: #fff;
    padding: 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    z-index: 1000;
    position: relative;
    border-left: 1px solid rgba(0, 0, 0, 0.12);
    border-right: 1px solid rgba(0, 0, 0, 0.12);
    .attachment-box {
      display: grid;
      grid-template-columns: repeat(4, max-content);
      overflow: auto;
      width: 101%;
    }
  }
`;

export const ContainerConversationIcon = styled.div`
  width: 17px;
`;

export const Text = styled.p`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 150px;
`;

export const BackgroundTitle = styled.div`
  border-radius: 2px;
  background-color: ${({ isClient }) => (isClient ? colors.whiteSmoke : 'transparent')};
  align-items: center;
  height: 34px;
  margin-bottom: 15px;
`;

export const ContactsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(9, max-content);
  padding-left: 0;
  h6 {
    margin-bottom: 10px;
    margin-left: 8px;
    ::after {
      content: ',';
    }
  }
`;

export const SearchDiv = styled.div`
  width: 100%;
  padding-top: 7px;
  justify-content: space-between;
  @media ${device.sm} {
    padding-left: 0;
  }
  @media ${device.md} {
    padding-left: 0;
  }
  @media ${device.lg} {
    padding-left: 0;
  }
  @media ${device.xl} {
    padding-left: 20px;
  }
`;

export const SearchNotifyDiv = styled.div`
  width: 100%;
  padding-top: 7px;
`;

export const SearchClients = styled(TextField)`
  margin-top: 6px !important;
  width: 100% !important;
  input {
    color: ${colors.gullGrey};
    font-size: ${fontSizes.sm}px;
    letter-spacing: 0;
    line-height: 18px;
  }
`;

export const HrClient = styled.hr`
  margin-top: -1rem;
  @media ${device.sm} {
    width: 99%;
  }
  @media ${device.md} {
    width: 99%;
  }
  @media ${device.lg} {
    width: 90%;
  }
  @media ${device.xl} {
    width: 90%;
  }
`;

export const SearchClientsForm = styled.div`
  width: 100%;
  @media ${device.sm} {
    margin-left: -5px;
  }
  @media ${device.md} {
    margin-left: -5px;
  }
  @media ${device.lg} {
    margin-left: -5px;
  }
  @media ${device.xl} {
    margin-left: -17px;
  }
`;

export const Ul = styled.ul`
  overflow: auto;
  height: 100%;
  @media ${device.xl} {
    max-height: ${({ isCurrentNotification }) => (isCurrentNotification ? '760px' : '604px')};
  }
`;

export const CollapseClient = styled.div`
  border-radius: 18px;
  background-color: ${colors.gullGrey};
  margin-top: 10px;
  margin-right: 5px;
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 27px;
  width: 27px;
  svg {
    fill: ${colors.white};
    height: 16px;
    width: 27px;
  }
  @media ${device.sm} {
    margin-left: 19px;
  }
  @media ${device.md} {
    margin-left: 19px;
  }
  @media ${device.lg} {
    margin-left: 19px;
  }
  @media ${device.xl} {
    margin-left: 0;
  }
`;

export const AdvisorFormWrapper = styled.form`
  padding: 0 20px;
  padding-bottom: 26px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .row-title {
    border-bottom: 1px solid ${colors.spanishGray};
    padding: 0;
    padding-bottom: 17px;
    width: 100%;

    h3 {
      color: ${colors.black};
      font-family: ${fonts.default};
      font-size: ${fontSizes.xlg}px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 24px;
    }
  }
  .advisor-form-container {
    .select-advisor-text {
      color: ${colors.black};
      font-family: ${fonts.default};
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 18px;
    }
    .dropdown-search-container {
      display: flex;
      flex-direction: column;
      position: relative;
      padding-top: 8px;
      .label-advisor-text {
        color: ${colors.black};
        font-family: ${fonts.default};
        font-size: 16px;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 19px;
        .required-mark {
          color: ${colors.error};
        }
      }
    }
  }
`;

export const Individual = styled.div`
  height: 45px;
  width: 100%;
  padding: 15px 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ showTypeNotifications }) =>
    !showTypeNotifications ? colors.whiteSmoke : 'transparent'};
  &:hover {
    background-color: ${colors.whiteSmoke};
  }
  span {
    color: ${colors.black};
    font-family: ${fonts.default};
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 19px;
  }
`;

export const Massive = styled.div`
  height: 45px;
  width: 100%;
  padding: 15px 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ showTypeNotifications }) =>
    showTypeNotifications ? colors.whiteSmoke : 'transparent'};
  &:hover {
    background-color: ${colors.whiteSmoke};
  }
  span {
    color: ${colors.black};
    font-family: ${fonts.default};
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 19px;
  }
`;
